// extracted by mini-css-extract-plugin
export var active = "_7x-d";
export var blink = "_7x-e";
export var container = "_7x-5";
export var controls = "_7x-0";
export var controlsRight = "_7x-1";
export var fakeCursor = "_7x-c";
export var hidden = "_7x-b";
export var quillContainerSmall = "_7x-7";
export var quillEditor = "_7x-6";
export var quillEditorSmall = "_7x-8";
export var quillFormatButtons = "_7x-a";
export var quillToolbar = "_7x-9";
export var removePadding = "_7x-2";
export var state = "_7x-3";
export var stateTitle = "_7x-4";